$(function () {
    $('.check-all-checkbox').click(function (e) {
        $("#panel-"+this.value+" .download-item").prop('checked', $(this).prop('checked'));
    });
});
